module.exports = __webpack_public_path__ + "img/radio.9c726989.gif";